export default __webpack_public_path__ + "static/media/product-login.25f91b6c.png";